    // EditPatientForm.js

    import React, { useState, useEffect } from "react";

    const EditPatientForm = ({ data, onSubmit }) => {
    const [values, setValues] = useState({
        full_name: data.full_name,
        email: data.email,
        contact: data.contact,
        data:[
            {
                "label":"1",
                "type":"1",
                "required":"1",
                "value":"1",
                "values":"1"
            }
        ]
        // Add other form fields for editing patient details
    });

    useEffect(() => {
        // Update the form values whenever the data prop changes
        setValues({
        full_name: data.full_name,
        email: data.email,
        contact: data.contact,
        data:[
            {
                "label":"1",
                "type":"1",
                "required":"1",
                "value":"1",
                "values":"1"
            }
        ]
        // Update other form fields here if needed
        });
    }, [data]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log("Changing", name, value);
        setValues((prevValues) => ({
        ...prevValues,
        [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(values);
    };

    return (
        <div className=" w-full">
        <form onSubmit={handleSubmit}>
            {/* Render the form fields for editing patient details */}
            <div>
            <label htmlFor="name">Name:</label>
            <input
                type="text"
                name="full_name"
                value={values.full_name}
                onChange={handleChange}
            />
            </div>

            <div>
            <label htmlFor="email">Email:</label>
            <input
                type="email"
                name="email"
                value={values.email}
                onChange={handleChange}
            />
            </div>

            <div>
            <label htmlFor="contact">Contact:</label>
            <input
                type="text"
                name="contact"
                value={values.contact}
                onChange={handleChange}
            />
            </div>
            


            <button type="submit" className="button w-full mt-5">Proceed</button>
        </form>
        </div>
    );
    };

    export default EditPatientForm;
